import React, { Suspense } from "react";
import { Navigate } from "react-router-dom";
import PropTypes from "prop-types";
import ProtectedRoute from "./ProtectedRoute";
import { useSelector } from 'react-redux';

const LazyRouteHOC = ({
  component: Component,
  fallback: Fallback,
  role,
  requiredPermission
}) => {
  const { isLoggedIn } = useSelector((state) => state.clientData);

  return isLoggedIn ? (
    <Suspense fallback={Fallback ? <Fallback /> : null}>
      <ProtectedRoute
        element={Component}
        allowedRoles={role}
        requiredPermission={requiredPermission}
      />
    </Suspense>
  ) : (
    <Navigate to="/login" />
  );
};

LazyRouteHOC.propTypes = {
  component: PropTypes.elementType.isRequired,
  fallback: PropTypes.elementType,
  isLoggedIn: PropTypes.bool.isRequired,
};

export default LazyRouteHOC;
